const getFaqArticleListApi = async (options?: ApiRestOptions) => {
  return apiFetchRequest<ApiRestResult<FaqArticleListResponse>>("/data/faq/articles", options);
};

export { getFaqArticleListApi };
